<template>
  <div class="flex-column section" style="padding-top: 10px;">
    <el-form label-width="90px" label-position="left" style="padding-top: 5px;height: 100%;">
      <el-row>
        <el-radio-group v-model="pageRadio" class="spacing" no="1">
          <el-radio label="mblNo" style="float:left">{{ $t('SeaExport.BlNo') }}</el-radio>
          <el-radio label="jobNo" style="float:left">{{ $t('SeaExport.BusinessNo') }}</el-radio>
        </el-radio-group>

        <el-input v-model="inputString" style="width: 150px" class="spacing" no="2" />

        <el-button type="primary" no="3" @click="queryHandler(false)">{{ $t('SeaExport.Query') }}</el-button>
        <el-button type="primary" no="4" @click="addCustomInfoHandler">{{ $t('SeaExport.Add2') }}</el-button>
        <el-button type="primary" no="5" @click="editCustomInfoHandler">{{ $t('SeaExport.Edit') }}</el-button>
        <el-button type="primary" no="6" @click="delCustomInfoHandler">{{ $t('SeaExport.Delete') }}</el-button>
      </el-row>
      <el-row style="height: 100%;">
        <div class="section grid-wrapper" style="padding-top: 5px;height: 100%;">
          <cargo-ag-grid
            config-module="9400001"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :grid-params.sync="gridParams"
            :check-main-record="false"
            :deselect-main-record="false"
            style="width: 100%; height:100%"
            @gridReady="onGridReady"
          />
        </div>
      </el-row>
    </el-form>

    <!-- 云文件上传对话框 -->
    <cargo-custom-info-file-upload
      :visible.sync="cloudFile.visible"
      :job="job"
      :title="cloudFile.title"
      :custom-info="cloudFile.customInfo"
      :document-type="cloudFile.documentType"
      :lob="lob"
      :show-all="true"
      @uploadDone="uploadDoneHandler"
    />

    <customs-info-dialog ref="customsInfoDialog" :visible.sync="editDialog.visible" :is-custom-info="true" :selected-customs-info="selectedCustomsInfo" :job="job" @successHandler="successHandler" />
    <!--查看海关回执文件-->
    <customs-info-res-file-history-dialog :visible.sync="customsInfoFileDialog.visible" :customs-info="customsInfoFileDialog.customsInfo" :customs-info-key="customsInfoFileDialog.customsInfoKey" />
    <!-- 选择业务弹框 -->
    <job-list-window
      v-if="jobListWindow.visible"
      :visible.sync="jobListWindow.visible"
      :job-nos="jobListWindow.jobs"
      @selectJobNoHandler="selectJobNoHandler"
    />
  </div>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ServiceCodeDialog from '@/views/cargo/v0/SystemMaintenance/components/ServiceCodeDialog'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import { File } from '@/class/model/booking/File'
import * as FileType from '@/class/cargo/model/parameters/FileType'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { saveFile } from '@/api/seaExport/file'
import { customsInfoDeleteAll } from '@/api/seaExport/customsInfo'
import CustomsInfoDialog from '@/components/Cargo/Job/customsInfoDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import { AgGridVue } from 'ag-grid-vue'
import { Job } from '@/class/model/booking/Job'
import { CustomsInfo } from '@/class/model/booking/CustomsInfo'
import customsInfoResFileHistoryDialog from '@/components/Cargo/FileUpload/customsInfoResFileHistoryDialog'
import { queryByNoOrMblCustomFunc } from '@/api/booking/job'
import cargoCustomInfoFileUpload from '@/components/Cargo/Common/cargoCustomInfoFileUpload'
import JobListWindow from '@/components/Cargo/Job/uploadFile/jobListWindow'
import { getLoading } from '@/utils/utilBaseElement'
import AnalysisDuration from '../AnalysisDuration'
import { getStateByCode } from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cacheName, cache } from '@/utils/cacheManager'

export default {
  name: 'CustomInfo',
  components: { JobListWindow, cargoCustomInfoFileUpload, CustomsInfoDialog, customsInfoResFileHistoryDialog, ServiceCodeDialog, CargoAdvanceSelect, CargoButtonGroupSlider, AgGridVue },
  props: {
    lob: { type: String, required: true }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      loading: null,
      gridApi: null,
      xinHaoQiApi: 0,
      job: new Job().fillDefaultValue().getData(),
      isNew: false,
      cloudFile: {
        visible: false,
        title: '',
        customInfo: new CustomsInfo(),
        documentType: 'csFile'
      },
      jobListWindow: {
        visible: false,
        jobs: []
      },
      inputString: '',
      pageRadio: 'mblNo',
      gridParams: {},
      rowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        context: {
          componentParent: this
        },
        onRowClicked: this.selectItemClickHandler,
        onRowSelected: this.onRowClickedHandler
      },
      editDialog: {
        visible: false
      },
      customsInfoFileDialog: {
        visible: false,
        customsInfo: null,
        customsInfoKey: null
      },
      selectedCustomsInfo: {}
    }
  },
  computed: {
    openOujianCustoms() {
      return Number(cache.config.get('openOujianCustoms')) === 1
    },
    closeXhqCustoms() { // 关闭信号旗报关参数
      return this.xinHaoQiApi === 0
    },
    columnDefs() {
      const list = [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          suppressSorting: true,
          suppressMenu: true,
          suppressSizeToFit: true,
          suppressResize: true
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.BlNo'),
          field: 'mblNo',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.OperatingCompany'),
          field: 'companyCname',
          width: 200
        },
        {
          headerName: this.$t('SeaExport.CustomsCode'),
          field: 'tenDigitCode',
          width: 200
        },
        {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'soNo',
          colId: 'soNo'
        },
        {
          headerName: this.$t('SeaExport.DateOfCustomsDeclaration'),
          field: 'customsDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsReceiptState'),
          field: 'RECEIPT_CODE',
          suppressMenu: true,
          width: 200
        },
        {
          headerName: this.$t('SeaExport.CustomsReceiptFile'),
          field: '',
          colId: 'customsReceiptFile',
          width: 120,
          cellRenderer: params => {
            return '<a style="color: #0A0AFF; text-decoration: underline">' + this.$t('FileHistory.view') + '</a>'
          },
          onCellClicked: (params) => {
            if (params.event.target.tagName === 'A') {
              this.showCustomsInfoResFileDialog(params.data)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.StatusOfCustomsDeclaration'),
          field: 'declareCustomsState',
          width: 120,
          cellRenderer: (params) => {
            return this.customsStateLabFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CommodityInspectionOrNot'),
          field: 'commodityInspection',
          width: 120,
          cellRenderer: (params) => {
            return this.commodityLabFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsInspectionOrNot'),
          field: 'spotInspection',
          width: 120,
          cellRenderer: (params) => {
            return this.commodityLabFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsNo'),
          field: 'customsNo',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.UploadFile'),
          field: '',
          colId: 'customsReceiptFile',
          width: 120,
          cellRenderer: params => {
            return '<a style="color: #0A0AFF; text-decoration: underline">' + this.$t('SeaExport.CustomsFile') + '</a>&nbsp;&nbsp;&nbsp;<a style="color: #0A0AFF; text-decoration: underline">' + this.$t('SeaExport.Chargeback') + '</a>'
          },
          onCellClicked: (params) => {
            this.customFileUploadHandler(params)
          }
        }
      ]
      if (!this.openOujianCustoms && this.closeXhqCustoms) {
        list.push({
          headerName: this.$t('CargoMsg.Cargo_CustomsDeclarationNo'),
          field: 'customsDeclarationNo',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AnalysisStatus'),
          colId: 'analysisStatus',
          field: 'analysisStatus',
          cellRendererFramework: AnalysisDuration,
          filterValueGetter: (params) => {
            const s = getStateByCode(SystemConstants.ANALYSIS_STATUS_LIST, params.value)
            if (s) {
              return this.$store.getters.language === 'zh' ? s.chineseName : s.englishName
            } else {
              return ''
            }
          },
          width: 240
        },
        {
          headerName: this.$t('SeaExport.Quantity2'),
          field: 'quantity',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.ExchangeRate'),
          field: 'rate',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SystemFee'),
          field: 'systemFee',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InsurancePremium'),
          field: 'insurancePremium',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProcessingFee'),
          field: 'processingFee',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FOBValue'),
          field: 'freeOnBoard',
          width: 120
        })
      }
      return list
    }
  },
  watch: {
  },
  created() {
    cache.load(cacheName.USER, cacheName.CONFIG)
    this.xinHaoQiApi = Number(cache.config.get('xinHaoQiApi'))
  },
  methods: {
    onGridReady(p) {
      this.gridApi = p.api
    },
    // 新增报关单
    addCustomInfoHandler() {
      this.queryHandler(true)
    },
    // 新增/编辑成功都走这里
    async successHandler(data) {
      if (this.isNew) {
        this.addFile(data)
        this.isNew = false
      } else {
        await this.queryHandler(false)
      }
    },
    commodityLabFun(commodityInspection) {
      const val = Boolean(commodityInspection)
      if (val) {
        return this.$t('Message.Yes')
      }
      return this.$t('Message.No')
    },
    addFile(customsInfo) {
      const file = new File().fillDefaultValue().getData()
      file.jobUuid = this.job.uuid
      file.jobNo = this.job.jobNo
      file.fileType = String(FileType.BGD_TYPE.code)
      file.tenDigitCode = customsInfo.tenDigitCode
      file.companyCname = customsInfo.companyCname
      file.customsBroker = customsInfo.customsBroker
      file.fileNo = customsInfo.soNo
      file.customsNo = customsInfo.customsNo
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.job.customerId)
      file.receiveDate = new Date()
      file.receiveCompany = companyCache ? companyCache.chineseName : ''
      file.receivePerson = this.job.customerContact
      file.receiveTel = this.job.contactTelephone
      file.expressAddress = companyCache ? companyCache.address : ''
      file.state = 0
      file.branchId = this.job.opOffice
      file.inputBy = this.$store.getters.userId
      file.inputByDep = this.$store.getters.currentDeptId
      file.inputDate = new Date()
      file.tax = false
      file.originFileId = customsInfo.uuid
      file.currentHolder = this.$store.getters.userId
      file.remark = customsInfo.remarks
      saveFile(file).then(res => {
        this.queryHandler(false)
      })
    },
    // 编辑报关单
    editCustomInfoHandler() {
      const arr = Object.keys(this.selectedCustomsInfo)
      if (arr.length === 0) {
        this.$message.info(this.$t('Message.PleaseSelectARecord2'))
        return
      }
      this.$nextTick(() => {
        this.$refs.customsInfoDialog.onShow('edit')
        this.isNew = false
        this.editDialog.visible = true
      })
    },
    onRowClickedHandler(event) {
      if (!event || !event.data) return
      this.selectedCustomsInfo = event.data
      this.setJobData(event.data)
      // 全部勾选时，取消掉选中
      // const l = this.gridApi.getSelectedRows()
      // if (this.rowData.length === l.length) {
      //   this.selectedCustomsInfo = {}
      // }
    },
    selectItemClickHandler(event) {
      if (!event || !event.data) return
      this.selectedCustomsInfo = event.data
      this.setJobData(event.data)
    },
    setJobData(data) {
      if (!data) {
        return
      }
      this.job.jobNo = data.jobNo
      this.job.uuid = data.jobUuid
      this.job.mbl = data.mblNo
      this.job.customsBroker = data.customsBroker
      this.job.lob = this.lob
      this.job.soNo = data.soNo
      this.job.customerId = data.customerId
      this.job.preverifyState = data.preverifyState
      this.job.jobState = data.jobState
      this.job.booking = data.booking
    },
    queryHandler(isAdd) {
      this.doQueryHandler(isAdd)
      this.refreshCustomsAnalysis(1)
    },
    // 这里请求后端获取解析结果
    refreshCustomsAnalysis(i) {
      setTimeout(() => {
        if (i > 10) {
          return
        }
        if (this.rowData && this.rowData.length > 0) {
          const pendingParsing = this.rowData.filter(e => e.analysisStatus === SystemConstants.ANALYSIS_STATUS_1.code)
          if (pendingParsing && pendingParsing.length > 0) {
            this.doQueryHandler(false)
            this.refreshCustomsAnalysis(i++)
          }
        }
      }, i === 1 ? 10000 : 5000)
    },
    // 列表查询
    doQueryHandler(isAdd) {
      const t = this.inputString
      // 初始化参数
      this.params = {}
      if (this.pageRadio === 'mblNo') {
        if (!t || !t.trim()) {
          this.$message.warning(this.$t('queryJob.enterBillOfLadingNumber'))
          return
        }
        this.params.mblNo = t
        this.params.branchId = 0
        this.params.lob = this.lob
      } else if (this.pageRadio === 'jobNo') {
        if (!t || !t.trim()) {
          this.$message.warning(this.$t('Message.PleaseEnterTheBusinessNumber'))
          return
        }
        this.params.jobNo = t
        this.params.branchId = this.$store.getters.currentOfficeId
        this.params.lob = this.lob
      }
      // 根据业务编号 或者 提单号查询业务
      this.loading = getLoading()
      queryByNoOrMblCustomFunc(this.params).then(res => {
        this.loading.close()
        if (res.data && res.data.length > 0) {
          if (isAdd) {
            if (res.data.length === 1) {
              const j = res.data[0]
              this.doAddHandler(j)
            } else {
              // 多个业务，弹框选一下
              this.jobListWindow.jobs = res.data
              this.jobListWindow.visible = true
            }
          } else {
            this.rowData = []
            if (res.data.length === 1) {
              const j = res.data[0]
              this.rowHandler(j)
            } else {
              // 多个业务 全部显示
              for (let i = 0; i < res.data.length; i++) {
                const j = res.data[i]
                this.rowHandler(j)
              }
            }
            this.selectedCustomsInfo = {}
            this.gridApi.clearFocusedCell()
          }
        } else {
          const text = this.pageRadio === 'mblNo' ? this.$t('SeaExport.BlNo') : this.$t('Payment.businessNumber')
          this.$message.warning(text + this.$t('Message.NonExistent'))
        }
      }).catch((err) => {
        this.loading.close()
        this.$message.error(err)
      }).finally(() => {
        this.loading.close()
      })
    },
    rowHandler(j) {
      if (j.customsInfoList) {
        for (let i = 0; i < j.customsInfoList.length; i++) {
          const customsInfo = j.customsInfoList[i]
          customsInfo['jobNo'] = j.jobNo
          customsInfo['mblNo'] = j.mblNo
          this.rowData.push(customsInfo)
        }
      }
    },
    // 处理新增
    doAddHandler(j) {
      // 设置业务数据
      this.job.jobNo = j.jobNo
      this.job.uuid = j.uuid
      this.job.mbl = j.mblNo
      this.job.customsBroker = j.customsBroker
      this.job.lob = this.lob
      this.job.soNo = j.soNo
      this.job.customerId = j.customerId
      this.job.preverifyState = j.preverifyState
      this.job.jobState = j.jobState
      this.job.booking = j.booking
      this.$nextTick(() => {
        this.$refs.customsInfoDialog.onShow('add')
        this.isNew = true
        this.editDialog.visible = true
      })
    },
    // 选择后的业务 继续新增
    selectJobNoHandler(data) {
      this.doAddHandler(data)
    },
    customsStateLabFun(declareCustomsState) {
      if (declareCustomsState === 1) {
        return this.$t('SeaExport.Recorded')
      } else if (declareCustomsState === 2) {
        return this.$t('SeaExport.ListPulled')
      } else if (declareCustomsState === 3) {
        return this.$t('SeaExport.AtReception')
      } else if (declareCustomsState === 4) {
        return this.$t('SeaExport.CustomsDeclared')
      } else if (declareCustomsState === 5) {
        return this.$t('SeaExport.Undeclared')
      } else if (declareCustomsState === 6) {
        return this.$t('SeaExport.CustomsExamination')
      } else if (declareCustomsState === 7) {
        return this.$t('SeaExport.InspectionExamination')
      } else if (declareCustomsState === 8) {
        return this.$t('SeaExport.ExamedWithoutReleasing')
      } else if (declareCustomsState === 9) {
        return this.$t('SeaExport.AmendDeclaration')
      } else if (declareCustomsState === 10) {
        return this.$t('SeaExport.NotifyToDeclare')
      } else if (declareCustomsState === 11) {
        return this.$t('SeaExport.CustomsHasCheck')
      } else if (declareCustomsState === 12) {
        return this.$t('SeaExport.CustomsExamed')
      } else if (declareCustomsState === 13) {
        return this.$t('SeaExport.CustomsOneRelease')
      } else if (declareCustomsState === 14) {
        return this.$t('SeaExport.CustomsRelease2')
      }
      return this.$t('SeaExport.UnknownState')
    },
    delCustomInfoHandler() {
      if (!this.selectedCustomsInfo || !this.selectedCustomsInfo.uuid) {
        this.$message.info(this.$t('Message.PleaseSelectARecord2'))
        return
      }
      this.$confirm(this.$t('Message.SureDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const rows = []
        rows.push(this.selectedCustomsInfo.uuid)
        customsInfoDeleteAll(rows).then(res => {
          this.queryHandler(false)
        })
      }).catch(() => {
      })
    },
    // 回执文件弹窗
    showCustomsInfoResFileDialog(data) {
      if (data) {
        this.customsInfoFileDialog.customsInfo = data
        this.customsInfoFileDialog.customsInfoKey = data.uuid
        this.customsInfoFileDialog.visible = true
      }
    },
    uploadDoneHandler(data) {

    },
    customFileUploadHandler(params) {
      this.cloudFile.visible = true
      this.cloudFile.customInfo = this.selectedCustomsInfo
      if (params.event.target.innerHTML === this.$t('SeaExport.CustomsFile')) {
        this.cloudFile.documentType = 'csFile'
        this.cloudFile.title = this.$t('Message.UploadCustomsDeclarationFile')
      }
      if (params.event.target.innerHTML === this.$t('SeaExport.Chargeback')) {
        this.cloudFile.documentType = 'Oback'
        this.cloudFile.title = this.$t('Message.UploadChargebackFile')
      }
    }
  }
}
</script>

<style scoped>
.flex-column {
  display: flex;
  flex-direction: column;
}
.row-constant span {
  color: #67c23a;
}
.spacing {
  padding-right: 10px;
}
</style>
